export default "__VITE_ASSET__0d7680ca__"